/*
 * PrimeVue 4 Checkbox passthrough.
 *
 * In unstyled mode the component renders:
 *   <div root data-p-checked="true|false">  ← we mark this as a Tailwind `group`
 *     <input>                                ← native; we hide its visual but keep
 *                                              it interactive (covers the box for
 *                                              click + a11y).
 *     <div box>                              ← visual square; styled via the
 *                                              parent's data-p-checked attribute
 *     <svg icon>                             ← checkmark, hidden when not checked
 *     </div>
 *   </div>
 *
 * `data-p-checked` lives on the ROOT, so child styling uses Tailwind's
 * `group-data-[…]:` variant rather than a direct `data-[…]:` on box/icon.
 */
const pt = {
    root: {
        class: [
            'group/checkbox relative inline-flex items-center justify-center',
            'w-4 h-4 cursor-pointer align-middle',
            'data-[p-disabled=true]:opacity-50 data-[p-disabled=true]:cursor-not-allowed'
        ]
    },
    input: {
        class: [
            'absolute inset-0 w-full h-full m-0 p-0',
            'opacity-0 cursor-pointer',
            'disabled:cursor-not-allowed'
        ]
    },
    box: {
        class: [
            'inline-flex items-center justify-center',
            'w-4 h-4 rounded-4',
            'border border-gray-300 bg-white',
            'transition-colors duration-fast',
            'group-hover/checkbox:border-teal',
            'group-data-[p-checked=true]/checkbox:bg-teal',
            'group-data-[p-checked=true]/checkbox:border-teal'
        ]
    },
    icon: {
        // PrimeVue's CheckIcon is a thin svg path with fill="currentColor".
        // Make it visually heavier by giving it the full box size and white fill.
        class: 'w-3.5 h-3.5 text-white'
    }
}

export default pt
